<template>
  <div>

    <Row class="search-con">
      <Col span="10">
      <Button @click="backHistory" class="search-btn">返回</Button>
      </Col>

      <Col span='5'>
      <h1>{{ formValidate.advertisement_type }}</h1>
      </Col>

    </Row>

    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">

      <FormItem label="原始标题">
        <Col span="10">
        <Input v-model="formValidate.org_video_title" type="textarea" placeholder="请填写视频标题"></Input>
        </Col>

        <Col span="7" offset="1">
        <Input v-model="formValidate.video_title_hint" type="textarea" placeholder="请填写优化提示:请帮我把标题改的更加美好一点"></Input>
        </Col>

        <Col span="2" offset="1">
        <Button type="info" :loading="loadding_array[1]"
          @click="chatgptText(formValidate.org_video_title, formValidate.video_title_hint, 1)">
          <span v-if="!loadding_array[1]">优化</span>
          <span v-else>优化中...</span>
        </Button>
        </Col>

        <Col span="2" offset="1" v-if='status != 4'>
        <Button type="primary" @click="handleSubmit('formValidate')" style="margin-left: 8px">保存</Button>
        </Col>

      </FormItem>

      <FormItem label="优化后标题">
        <Col span="18">
        <Input v-model="formValidate.chatgpt_video_title" type="textarea" placeholder="请填写优化后标题"></Input>
        </Col>
      </FormItem>

      <FormItem label="切片标题">

        <Col span="10">
        <Input v-model="formValidate.org_title" type="textarea" placeholder="请填写切片标题"></Input>
        </Col>

        <Col span="7" offset="1">
        <Input v-model="formValidate.org_title_hint" type="textarea" placeholder="请填写优化提示:请帮我把切片标题改的更加美好一点"></Input>
        </Col>

        <Col span="2" offset="1">
        <Button type="info" :loading="loadding_array[3]"
          @click="chatgptText(formValidate.org_title, formValidate.org_title_hint, 3)">
          <span v-if="!loadding_array[3]">优化</span>
          <span v-else>优化中...</span>
        </Button>
        </Col>
      </FormItem>

      <FormItem label="优化后切片标题">
        <Col span="18">
        <Input v-model="formValidate.chatgpt_title" type="textarea" placeholder="请填写优化后文案"></Input>
        </Col>
      </FormItem>

      <FormItem label="封面标题">

        <Col span="10">
        <Input v-model="formValidate.cover_title" type="textarea" placeholder="请填写封面标题"></Input>
        </Col>

        <Col span="7" offset="1">
          <Input v-model="formValidate.cover_title_hint" type="textarea" placeholder="请填写优化提示:请帮我把封面标题改的更加美好一点"></Input>
        </Col>

        <Col span="2" offset="1">
        <Button type="info" :loading="loadding_array[4]"
          @click="chatgptText(formValidate.cover_title, formValidate.cover_title_hint, 4)">
          <span v-if="!loadding_array[3]">优化</span>
          <span v-else>优化中...</span>
        </Button>
        </Col>
      </FormItem>

      <FormItem label="优化后封面标题">
        <Col span="18">
        <Input v-model="formValidate.chatgpt_cover_title" type="textarea" placeholder="请填写优化后封面标题"></Input>
        </Col>
      </FormItem>

      <FormItem label="原始简介">
        <Col span="10">
        <Input v-model="formValidate.org_video_desc" type="textarea" placeholder="请填写原始简介"></Input>
        </Col>

        <Col span="7" offset="1">
        <Input v-model="formValidate.desc_hint" type="textarea" placeholder="请填写优化提示:请帮我把简介改的更加美好一点"></Input>
        </Col>

        <Col span="4" offset="1">
        <Button type="info" :loading="loadding_array[2]"
          @click="chatgptText(formValidate.org_video_desc, formValidate.desc_hint, 2)">
          <span v-if="!loadding_array[2]">优化</span>
          <span v-else>优化中...</span>
        </Button>
        </Col>

      </FormItem>

      <FormItem label="优化后简介">
        <Col span="18">
        <Input v-model="formValidate.chatgpt_video_desc" type="textarea" placeholder="请填写优化后简介"></Input>
        </Col>

      </FormItem>

      <FormItem label="原始文案" v-if="formValidate.video_work_type != 1">
        <Col span="10">
        <Input v-model="formValidate.org_text" type="textarea" placeholder="请填写文案"></Input>
        </Col>

        <Col span="7" offset="1">
        <Input v-model="formValidate.text_hint" type="textarea" placeholder="请填写优化提示:请帮我把文案改的更加美好一点"></Input>
        </Col>

        <Col span="2" offset="1">
        <Button type="info" :loading="loadding_array[0]"
          @click="chatgptText(formValidate.org_text, formValidate.text_hint, 0)">
          <span v-if="!loadding_array[0]">优化</span>
          <span v-else>优化中...</span>
        </Button>
        </Col>
      </FormItem>

      <FormItem label="优化后文案" v-if="formValidate.video_work_type != 1">
        <Col span="18">
        <Input v-model="formValidate.chatgpt_text" type="textarea" placeholder="请填写优化后文案"></Input>
        </Col>
      </FormItem>

      <template v-if="formValidate.video_work_type == 7">

        <FormItem label="剧情简介">
          <Col span="18">
          <Input v-model="formValidate.script" type="textarea" placeholder="请填写"></Input>
          </Col>
        </FormItem>

        <FormItem label="产品型号">
          <Col span="18">
          <Input v-model="formValidate.product" type="text" placeholder="请填写"></Input>
          </Col>
        </FormItem>

        <FormItem label="产品图片">
          <Col span="10">
          <input type="file" accept=".jpg,.png,.jpeg" @change="handleProductPathChange" ref="productPathFileInput" />
          </Col>
          <Col span='14'>
          <label class="search-label">{{ show_product_path }}</label>
          </Col>
        </FormItem>

        <template v-for="(item, index) in formValidate.users">
          <FormItem :label="'角色' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="text" v-model="item.value" placeholder="请填写"></Input>
              </Col>

              <Col span="4" offset="1">
              <Button type="error" @click="handleUserRemove(index)">删除</Button>
              </Col>
            </Row>
          </FormItem>
        </template>

        <FormItem>
          <Row>
            <Col span="12">
            <Button @click="handleUserAdd" icon="md-add">添加角色</Button>
            </Col>
          </Row>
        </FormItem>

        <template v-for="(item, index) in formValidate.props">
          <FormItem :label="'道具' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="text" v-model="item.value" placeholder="请填写"></Input>
              </Col>

              <Col span="4" offset="1">
              <Button type="error" @click="handlePropRemove(index)">删除</Button>
              </Col>
            </Row>
          </FormItem>
        </template>

        <FormItem>
          <Row>
            <Col span="12">
            <Button @click="handlePropAdd" icon="md-add">添加道具</Button>
            </Col>
          </Row>
        </FormItem>

        <template v-for="(item, index) in formValidate.scripts">
          <FormItem :label="'场景' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="text" v-model="item.scene_value" placeholder="请填写"></Input>
              </Col>
              <Col span="4" offset="1">
              <Button type="error" @click="handleScriptRemove(index)">删除</Button>
              </Col>
            </Row>
          </FormItem>

          <FormItem :label="'话术' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="textarea" v-model="item.text_value" placeholder="请填写"></Input>
              </Col>
            </Row>
          </FormItem>
          </FormItem>
        </template>

        <FormItem>
          <Row>
            <Col span="12">
            <Button @click="handleScriptAdd" icon="md-add">添加场景</Button>
            </Col>
          </Row>
        </FormItem>

      </template>

      <template v-if="formValidate.video_work_type == 4">
        <template v-for="(item, index) in formValidate.keywords">
          <FormItem :label="'关键字' + (index + 1)">
            <Row>
              <Col span="5">
              <Input type="text" v-model="item.value" placeholder="请填写"></Input>
              </Col>

              <Col span="12" offset="1">
              <Col span='14'>
              <input type="file" accept=".jpg,.png,.jpeg" @change="handleFileUpload($event, index)" />
              </Col>
              <Col span='10'>
              <label class="search-label">{{ item.name }}</label>
              </Col>
              </Col>
              <Col span="5" offset="1">
              <Button type="error" @click="handleKeywordRemove(index)">删除</Button>
              </Col>
            </Row>
          </FormItem>
        </template>

        <FormItem>
          <Row>
            <Col span="12">
            <Button @click="handleKeywordAdd" icon="md-add">关键字</Button>
            </Col>
          </Row>
        </FormItem>

      </template>

      <template v-for="(item, index) in formValidate.goodItems">
        <FormItem :label="'金句评论' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" v-model="item.value" placeholder="请填写"></Input>
            </Col>
            <Col span="4" offset="1">
            <Button type="error" @click="handleGoodCommentRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>

      </template>

      <FormItem>
        <Row>
          <Col span="12">
          <Button @click="handleGoodAdd" icon="md-add">添加金句</Button>
          </Col>
        </Row>
      </FormItem>

      <template v-for="(item, index) in formValidate.blackItems">
        <FormItem :label="'黑粉评论' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" v-model="item.value" placeholder="请填写"></Input>
            </Col>
            <Col span="4" offset="1">
            <Button type="error" @click="handleBlackCommentRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>
      </template>

      <FormItem>
        <Row>
          <Col span="12">
          <Button @click="handleBlackAdd" icon="md-add">添加黑粉</Button>
          </Col>
        </Row>
      </FormItem>

      <!-- <FormItem label="字幕文件" prop="org_srt_path" v-if="formValidate.video_work_type!=2 && formValidate.video_work_type!=3">
          <input type="file" accept=".srt"  @change="handleSrtFileChange"/>
          <label class="search-label">{{show_org_srt_path}}</label>
      </FormItem> -->

    </Form>

    <Card v-if="formValidate.video_work_type == 1">
      <tables editable :columns="columns" v-model="tableData" :loading="tableLoading" />
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables/table-only.vue'
// import saveAs from '@/api/FileSaver';
import moment from 'moment'
import { uploadFile } from '@/api/uploadOss'
import { getCheckSrtDetail, editCheckSrtTask, sendChatGpt, getSceneList, sendChatGptSystem } from '@/api/data'
const { v4: uuidv4 } = require('uuid')

export default {
  name: 'finance',
  components: {
    Tables
  },
  data () {
    return {
      show_product_path: '',
      formValidate: {
        id: '',
        org_text: '',
        cover_title_hint: '',
        cover_title: '',
        chatgpt_cover_title: '',
        chatgpt_text: '',
        org_video_title: '',
        chatgpt_video_title: '',
        org_video_desc: '',
        chatgpt_video_desc: '',
        blackItems: [],
        goodItems: [],
        video_work_type: '',
        video_title_hint: '',
        desc_hint: '',
        text_hint: '',
        chatgpt_title: '',
        org_title: '',
        org_title_hint: '',
        scene_id: '',
        users: [],
        props: [],
        advertisement_type: '',
        scripts: [],
        script: '',
        product_url: '',
        product: '',
        keywords: []
      },
      ruleValidate: {
      },
      loadding_array: [false, false, false, false],
      status: '',
      show_org_srt_path: '',
      show_translate_srt_path: '',
      page: 1,
      total: 0,
      pageSize: 10,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editUserModal: false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      classify_id: '',
      startTime: '',
      endTime: '',
      dy_id: '',
      id: '',
      tag_status: '',
      live_id: '',
      tagStatusIds: [],
      sceneIds: [],
      tag_id: '',
      blacks: [{ id: 1, name: '是' }, { id: 0, name: '否' }],
      is_black: '',
      tagStatusIds: [{ id: 1, name: '已确认' }, { id: 0, name: '未确认' }],
      selectId: [],
      tag_id: '',
      tagIds: [],
      columns: [
        { type: 'index', title: '序号', width: 100, align: 'center', align: 'center' },
        { title: '时间轴', key: 'title', editable: true, align: 'center' },
        { title: '原话术', key: 'text', editable: true, align: 'center' },
        {
          title: '修改后话术',
          key: 'after_text',
          editable: true,
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                value: params.row.text,
                size: 'small',
                type: 'textarea'
              },
              on: {
                'on-change': (event) => {
                  this.tableData[params.index].text = event.target.value
                }
              }
            })
          }
        },
        {
          title: '操作',
          editable: true,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.deleteSrt(params.index)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ],
      tableData: []
    }
  },
  methods: {
    async handleFileUpload (e, index) {
      const file = e.target.files[0]
      if (!file) return
      try {
        let currentDate = moment().format('YYYY-MM-DD')
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        let result = await uploadFile('short_video/' + currentDate + '/check_srt/' + uuid + name, file)
        if (result != '') {
          this.formValidate.keywords[index].url = result
          var array = result.split('/')
          this.formValidate.keywords[index].name = array[array.length - 1]
          this.$Message.info('上传成功')
        } else {
          this.$Message.error('上传失败')
        }
      } catch (error) {
        this.$Message.error('上传失败')
      }
    },
    async handleProductPathChange (e) {
      const file = e.target.files[0]
      if (!file) return
      try {
        let currentDate = moment().format('YYYY-MM-DD')
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        const result = await uploadFile('short_video/' + currentDate + '/check_srt/' + uuid + name, file)
        if (result != '') {
          this.formValidate.product_url = result
          this.$Message.info('上传成功')
        } else {
          this.$Message.error('上传失败')
          this.$refs.productPathFileInput.value = ''
        }
      } catch (error) {
        this.$Message.error('上传失败')
        this.$refs.productPathFileInput.value = ''
      }
    },
    chatgptText (text, hint, index) {
      try {
        this.$set(this.loadding_array, index, true)
        let data = new FormData()
        data.set('message', text)
        data.set('model', 'gpt-4-turbo')
        data.set('system', hint + '。请使用json格式返回, 返回的内容放在json里的text字段')
        sendChatGptSystem(data).then((res) => {
          this.$set(this.loadding_array, index, false)
          if (res.data.code == 200) {
            this.$Message.success('优化成功!')
            if (index == 0) {
              this.formValidate.chatgpt_text = res.data.data
            } else if (index == 1) {
              this.formValidate.chatgpt_video_title = res.data.data
            } else if (index == 2) {
              this.formValidate.chatgpt_video_desc = res.data.data
            } else if (index == 3) {
              this.formValidate.chatgpt_title = res.data.data
            } else if (index == 4) {
              this.formValidate.chatgpt_cover_title = res.data.data
            }
          } else {
            this.$set(this.loadding_array, index, false)
            this.$Message.error('优化失败!')
          }
        })
          .catch((err) => {
            this.$set(this.loadding_array, index, false)
            this.$Message.error('优化失败!')
          })
      } catch (error) {
        this.$set(this.loadding_array, index, false)
      }
    },
    deleteSrt (index) {
      this.tableData.splice(index, 1)
    },
    handleScriptAdd () {
      var data = {
        scene_value: '',
        desc_value: '',
        text_value: ''
      }
      this.formValidate.scripts.push(data)
    },
    handleScriptRemove (index) {
      this.formValidate.scripts.splice(index, 1)
    },
    handleUserAdd () {
      this.formValidate.users.push({ 'value': '' })
    },
    handlePropAdd () {
      this.formValidate.props.push({ 'value': '' })
    },
    handleKeywordAdd () {
      this.formValidate.keywords.push({ 'value': '', 'url': '', 'name': '' })
    },
    handleUserRemove (index) {
      this.formValidate.users.splice(index, 1)
    },
    handleKeywordRemove (index) {
      this.formValidate.keywords.splice(index, 1)
    },
    handlePropRemove (index) {
      this.formValidate.props.splice(index, 1)
    },
    handleGoodAdd () {
      this.formValidate.goodItems.push({ 'value': '' })
    },
    handleBlackAdd () {
      this.formValidate.blackItems.push({ 'value': '' })
    },
    handleGoodCommentRemove (index) {
      this.formValidate.goodItems.splice(index, 1)
    },
    handleBlackCommentRemove (index) {
      this.formValidate.blackItems.splice(index, 1)
    },
    async handleSrtFileChange (e) {
      const file = e.target.files[0]
      if (!file) return
      // 解析srt文件
      const reader = new FileReader()
      var srtText = ''
      reader.onload = e => {
        srtText = e.target.result
        var srt_array = this.parseSRT(srtText)
        this.tableData = []
        for (var i = 0; i < srt_array.length; i++) {
          var item = srt_array[i]
          this.tableData.push({ 'startTime': item.startTime, 'endTime': item.endTime, 'text': item.text, 'after_text': item.text })
        }
      }
      reader.readAsText(file)
    },
    generateSRT (subtitles) {
      let srtContent = ''
      subtitles.forEach((subtitle, index) => {
        const sequenceNumber = index + 1
        const startTime = subtitle.startTime
        const endTime = subtitle.endTime
        srtContent += `${sequenceNumber}\n${startTime} --> ${endTime}\n${subtitle.translate_text}\n\n`
      })
      return srtContent
    },
    parseSRT (content) {
      // 按行拆分内容
      const lines = content.trim().split(/\r?\n/)
      const subtitles = []

      // 用于临时存储每个字幕块的变量
      let subtitleBlock = {
        index: null,
        startTime: null,
        endTime: null,
        text: ''
      }

      // 遍历每一行内容
      lines.forEach(line => {
        if (!subtitleBlock.index) {
          // 解析字幕序号
          subtitleBlock.index = parseInt(line)
        } else if (!subtitleBlock.startTime) {
          // 解析时间轴的起始时间
          const [startTime, endTime] = line.split(' --> ').map(time => time.trim())
          subtitleBlock.startTime = startTime
          subtitleBlock.endTime = endTime
        } else if (line.trim() === '') {
          // 遇到空行时，保存当前字幕块并重置临时变量
          subtitles.push(subtitleBlock)
          subtitleBlock = {
            index: null,
            startTime: null,
            endTime: null,
            text: ''
          }
        } else {
          // 解析字幕文本内容
          subtitleBlock.text += line.trim() + ' '
        }
      })

      return subtitles
    },
    handleSubmit (name) {
      var formValidate = this.formValidate
      var blackItems = formValidate.blackItems
      var goodItems = formValidate.goodItems
      var scene = {
        users: this.formValidate.users,
        props: this.formValidate.props,
        scripts: this.formValidate.scripts,
        product: this.formValidate.product,
        product_url: this.formValidate.product_url,
        script: this.formValidate.script,
        keywords: this.formValidate.keywords
      }
      const data = {
        black_comment: JSON.stringify(blackItems),
        good_comment: JSON.stringify(goodItems),
        video_desc: formValidate.org_video_desc,
        video_title: formValidate.org_video_title,
        title: formValidate.org_title,
        cover_title: formValidate.cover_title,
        chatGpt_cover_title: formValidate.chatgpt_video_desc,
        text: formValidate.org_text,
        chatGpt_video_desc: formValidate.chatgpt_video_desc,
        chatGpt_video_title: formValidate.chatgpt_video_title,
        chatGpt_text: formValidate.chatgpt_text,
        chatGpt_title: formValidate.chatgpt_title,
        srt_json: JSON.stringify(this.tableData),
        scene_json: JSON.stringify(scene)
      }

      editCheckSrtTask(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success('成功!')
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error('失败!')
        })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    translate (params) {

    },
    covertTime (time_str) {
      var start_split = time_str.split(':')

      // 00:00:15,000  解析这个格式，转换成毫秒
      if (start_split.length > 2) {
        var hour_second = parseInt(start_split[0]) * 60 * 60 * 1000
        var m_second = parseInt(start_split[1]) * 60 * 1000
        var second_split = start_split[2].split(',')
        var second = 0
        var mm_second = 0
        if (second_split.length > 1) {
          second = parseInt(second_split[0]) * 1000
          mm_second = parseInt(second_split[1])
        }
        return hour_second + m_second + second + mm_second + ''
      }
    },
    setEditData (params) {
      this.formValidate.id = params.id.toString()
      this.formValidate.org_text = params.text
      this.formValidate.chatgpt_text = params.chatGpt_text
      this.formValidate.org_video_title = params.video_title
      this.formValidate.org_title = params.title
      this.formValidate.chatgpt_video_title = params.chatGpt_video_title
      this.formValidate.chatgpt_title = params.chatGpt_title
      this.formValidate.org_video_desc = params.video_desc
      this.formValidate.chatgpt_video_desc = params.chatGpt_video_desc
      this.formValidate.cover_title = params.cover_title
      this.formValidate.chatgpt_cover_title = params.chatGpt_cover_title
      this.formValidate.video_work_type = params.shortVideoTask.short_video_work_type_id.toString()
      this.formValidate.advertisement_type = params.shortVideoTask.advertisement_type_id == 1 ? '需要文本广告' : ''
      this.formValidate.scene_id = params.scene_id.toString()
      this.formValidate.goodItems = JSON.parse(params.good_comment)
      this.formValidate.blackItems = JSON.parse(params.black_comment)
      this.status = params.status

      if (params.scene_json != null) {
        var scene = JSON.parse(params.scene_json)
        this.formValidate.scripts = scene.scripts
        this.formValidate.props = scene.props
        this.formValidate.users = scene.users
        this.formValidate.product = scene.product
        this.formValidate.product_url = scene.product_url
        this.formValidate.script = scene.script
        this.formValidate.keywords = scene.keywords
        if (scene.product_url != null && scene.product_url != '') {
          var video_path_array = scene.product_url.split('/')
          this.show_product_path = video_path_array[video_path_array.length - 1]
        }
      }

      if (params.srt_json != null) {
        var srt_array = JSON.parse(params.srt_json)
        this.tableData = []
        for (var i = 0; i < srt_array.length; i++) {
          var item = srt_array[i]
          var endTime = this.covertTime(item.endTime)
          var startTime = this.covertTime(item.startTime)
          this.tableData.push({ 'title': item.startTime + '---' + item.endTime + '长度:' + (endTime - startTime) + '毫秒', 'text': item.text, 'after_text': item.after_text, 'startTime': item.startTime, 'endTime': item.endTime })
        }
      }
    },
    backHistory () {
      this.$router.go(-1)
    },
    setTableLoading (state) {
      this.tableLoading = state
    },
    getDetail () {
      var params = {
        id: this.id
      }
      getCheckSrtDetail(params).then((res) => {
        if (res.data.code == 200) {
          var detailData = res.data.data
          this.setEditData(detailData)
        } else {
          this.tableData = []
          this.total = 0
        }
        this.setTableLoading(false)
      })

      getSceneList().then((res) => {
        var workType = res.data.data.records
        var data = new Array()
        for (var i = 0; i < workType.length; i++) {
          data[i] = { id: workType[i].id.toString(), name: workType[i].name }
        }
        this.sceneIds = data
      })
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.getDetail()
  }
}
</script>
